import { SxProps } from '@mui/material';
import zeplinColor from 'theme/Color';

export const container: SxProps = {
  width: '100%',
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  backgroundColor: `${zeplinColor.Neutral1}`,
  padding: '11px',
  border: `1px solid ${zeplinColor.Neutral1}`,
  borderRadius: '14px',
  color: zeplinColor.BasicBlack,

  ':hover': {
    border: `1px solid ${zeplinColor.BasicBlack}`,
    cursor: 'pointer',
  },
};

export const logoContainer: SxProps = { width: '40px', height: '40px' };

export const textContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  alignItems: 'flex-start',
};

export const recentOpenContent: SxProps = {
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  gap: '6px',
};
